import { render } from "./EventsCard.vue?vue&type=template&id=442bf935&scoped=true&bindings={}"
import script from "./EventsCard.vue?vue&type=script&lang=ts"
export * from "./EventsCard.vue?vue&type=script&lang=ts"

import "./EventsCard.vue?vue&type=style&index=0&id=442bf935&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-442bf935"

export default script